import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { etichetaValoareRapida } from "@/utils/targetareFiltreRapide";
import type { FiltruRapidDef } from "@/utils/targetareRaport";

type FiltruRapidProps = {
  def: FiltruRapidDef;
  optiuni: readonly string[];
  valori: string[];
  onComuta: (valoare: string) => void;
  onGoleste: () => void;
};

export function FiltruRapid({
  def,
  optiuni,
  valori,
  onComuta,
  onGoleste,
}: FiltruRapidProps) {
  const activ = valori.length > 0;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={activ ? "secondary" : "outline"}
          size="sm"
          className="h-8 gap-1"
          title={
            activ
              ? `${def.eticheta}: ${valori
                  .map((v) => etichetaValoareRapida(def, v))
                  .join(", ")}`
              : `Filtrează după ${def.eticheta.toLowerCase()}`
          }
        >
          {def.eticheta}
          {activ && (
            <span className="rounded bg-ds-blue-600 px-1 text-[10px] leading-4 text-white">
              {valori.length}
            </span>
          )}
          <ChevronDown className="h-3 w-3" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-72 p-2">
        <div className="max-h-72 space-y-0.5 overflow-auto">
          {optiuni.map((o) => (
            <label
              key={o}
              className="flex cursor-pointer items-center gap-2 rounded px-1 py-1 text-sm hover:bg-muted"
            >
              <Checkbox
                checked={valori.includes(o)}
                onCheckedChange={() => onComuta(o)}
              />
              <span className="truncate">{etichetaValoareRapida(def, o)}</span>
            </label>
          ))}
          {optiuni.length === 0 && (
            <p className="px-1 py-1 text-xs text-muted-foreground">
              Nicio valoare disponibilă
            </p>
          )}
        </div>
        {activ && (
          <Button
            variant="ghost"
            size="sm"
            className="mt-1 w-full"
            onClick={onGoleste}
          >
            Șterge selecția
          </Button>
        )}
      </PopoverContent>
    </Popover>
  );
}
